<template>
	<header
		class="fixed top-0 w-full z-50"
		:class="[openNav ? 'bg-gradient-to-tr from-color-1 to-color-2' : '', stickyHeader ? 'lockedHeader' : '']"
		v-scroll="handleScroll"
	>
		<div
			class="flex flex-wrap flex-col lg:flex-row mx-8 mx-auto"
			style="max-width: 1500px"
		>
			<div class="flex flex-row items-center justify-between p-3 lg:p-1">
				<router-link to="/">
					<img
						src="../assets/images/logo.png"
						width="50px"
						height="50px"
						alt="AVP"
					/>
				</router-link>
				<button
					@click="openNav = !openNav"
					class="text-white pb-4 cursor-pointer leading-none px-3 py-1 lg:hidden outline-none focus:outline-none content-end ml-auto"
					type="button"
					aria-label="button"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						stroke="white"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
						class="feather feather-menu"
					>
						<line
							x1="3"
							y1="12"
							x2="21"
							y2="12"
						></line>
						<line
							x1="3"
							y1="6"
							x2="21"
							y2="6"
						></line>
						<line
							x1="3"
							y1="18"
							x2="21"
							y2="18"
						></line>
					</svg>
				</button>
			</div>
			<div
				:class="openNav ? 'flex flex-col max-w-xs' : 'hidden'"
				class="lg:hidden"
			>
				<router-link
					v-if="allowed"
					:to="{ path: '/oven' }"
					class="cursor-pointer text-white hover:text-white font-semibold mx-4"
				>
					ADMIN
				</router-link>
				<router-link
					:to="{ path: '/pza-market' }"
					class="cursor-pointer text-white hover:text-white font-semibold mx-4"
				>
					$PZA MARKET
				</router-link>
				<!-- <router-link :to="{ path: '/mvp' }" class="cursor-pointer text-white hover:text-white font-semibold mx-4">
					MVP
				</router-link> -->
				<a
					href="https://opensea.io/collection/averagepunks-"
					rel="noopener noreferrer"
					target="_blank"
					class="cursor-pointer text-white hover:text-white font-semibold mx-4"
					>Average Punks</a
				>
				<a
					href="https://opensea.io/collection/metaverse-punks-"
					rel="noopener noreferrer"
					target="_blank"
					class="cursor-pointer text-white hover:text-white font-semibold mx-4"
					>Metaverse Punks</a
				>
        <router-link
					:to="{ path: '/pza-dash' }"
					class="cursor-pointer text-white hover:text-white font-semibold mx-4"
				>
					PZA Dash
				</router-link>
				<!-- <router-link
          :to="{ path: '/', hash: '#roadmap' }"
          class="cursor-pointer text-white hover:text-white font-semibold mx-4"
        >
          ROADMAP
        </router-link> -->
				<!-- <router-link :to="{ path: '/', hash: '#metaverse' }" class="cursor-pointer text-white hover:text-white font-semibold mx-4">
					METAVERSE
				</router-link>
				<router-link :to="{ path: '/', hash: '#team' }" class="cursor-pointer text-white hover:text-white font-semibold mx-4">
					TEAM
				</router-link> -->
				<!-- <a
            href="whitepaper.pdf"
            target="_blank"
            class="cursor-pointer text-white hover:text-white font-semibold mx-4"
            >WHITEPAPER</a
          > -->
				<a
					@click="onBtnClick"
					class="px-3 pr-2 rounded cursor-pointer w-max text-white font-semibold my-4 mx-4 connect uppercase"
					>{{ btnText }}</a
				>
			</div>
			<div class="hidden lg:flex flex-grow items-center">
				<div
					class="md:ml-auto md:mr-auto font-4 pt-1 md:pl-32 pl-1 flex flex-wrap items-center md:text-base text-1xl md:justify-center justify-items-start"
				>
					<router-link
						v-if="allowed"
						:to="{ path: '/oven' }"
						class="cursor-pointer text-white hover:text-white font-semibold mx-4"
					>
						ADMIN
					</router-link>
					<router-link
						:to="{ path: '/pza-market' }"
						class="cursor-pointer text-white hover:text-white font-semibold mx-4"
					>
						$PZA MARKET
					</router-link>
					<router-link
						:to="{ path: '/', hash: '#team' }"
						class="cursor-pointer text-white hover:text-white font-semibold mx-4"
						>TEAM</router-link
					>
					<!-- <router-link :to="{ path: '/mvp' }" class="cursor-pointer text-white hover:text-white font-semibold mx-4">
						MVP
					</router-link> -->
					<div
						class="mx-4"
						style="position: relative"
					>
						<button
							class="cursor-pointer px-3 border py-1 rounded text-white hover:text-purple-700 hover:bg-white font-semibold uppercase"
							@click="showPunksMenu"
						>
							Buy a Punk
							<i class="fa-solid fa-caret-down ml-1"></i>
						</button>
						<ul
							v-if="showMenu"
							class="py-2 absolute top-full w-max"
							style="background-color: #fff; border-radius: 10px"
						>
							<li class="uppercase px-3 py-2 cursor-pointer text-purple-700 hover:text-white hover:bg-purple-700 bg-none">
								<a
									href="https://opensea.io/collection/averagepunks-"
									rel="noopener noreferrer"
									target="_blank"
									>Average Punks</a
								>
							</li>
							<li class="uppercase px-3 py-2 cursor-pointer text-purple-700 hover:text-white hover:bg-purple-700 bg-none">
								<a
									href="https://opensea.io/collection/metaverse-punks-"
									rel="noopener noreferrer"
									target="_blank"
									>Metaverse Punks</a
								>
							</li>
						</ul>
					</div>
					<div
						class="mx-4"
						style="position: relative"
					>
						<button
							class="cursor-pointer px-3 border py-1 rounded text-white hover:text-purple-700 hover:bg-white font-semibold uppercase"
							@click="showGamesMenu"
						>
							Games
							<i class="fa-solid fa-caret-down ml-1"></i>
						</button>
						<ul
							v-if="showAppList"
							class="py-2 absolute top-full w-max"
							style="background-color: #fff; border-radius: 10px"
						>
							<li class="uppercase px-3 py-2 cursor-pointer text-purple-700 hover:text-white hover:bg-purple-700 bg-none">
								<router-link
									:to="{ path: '/pza-dash' }"
									class="cursor-pointer text-purple-700 hover:text-white font-semibold mx-4"
								>
									PZA Dash
								</router-link>
							</li>
						</ul>
					</div>
					<a
						href="https://prettyaveragestore.com"
						target="_blank"
						class="cursor-pointer text-white hover:text-white font-semibold mx-4"
					>
						SHOP
					</a>
					<!-- <router-link
            :to="{ path: '/', hash: '#roadmap' }"
            class="
              cursor-pointer
              text-white
              hover:text-white
              font-semibold
              mx-4
            "
          >
            ROADMAP
          </router-link> -->
					<!-- <router-link
						:to="{ path: '/', hash: '#metaverse' }"
						class="cursor-pointer text-white hover:text-white font-semibold mx-4"
					>
						METAVERSE
					</router-link>
					<router-link :to="{ path: '/', hash: '#team' }" class="cursor-pointer text-white hover:text-white font-semibold mx-4">
						TEAM
					</router-link> -->
					<!-- <a
            href="whitepaper.pdf"
            target="_blank"
            class="cursor-pointer text-white hover:text-white font-semibold mx-4"
            >WHITEPAPER</a
          > -->
				</div>
				<div class="justify-self-end flex flex-row-reverse items-center">
					<a
						@click="onBtnClick"
						class="px-3 py-1 rounded flex items-center justify-center cursor-pointer text-white connect font-semibold uppercase"
						>{{ btnText }}</a
					>
					<a
						href="https://twitter.com/AveragePunksNFT"
						rel="noopener noreferrer"
						target="_blank"
						class="px-7 invisible md:visible"
					>
						<svg
							title="Twitter"
							width="30"
							height="17"
							viewBox="0 0 50 40"
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
						>
							<path
								data-v-54e46119=""
								d="M15.4528 40C34.0158 40 44.1732 24.6063 44.1732 11.2796C44.1732 10.8465 44.1732 10.4134 44.1536 9.98031C46.122 8.56299 47.8347 6.77166 49.1929 4.74409C47.3819 5.55118 45.4331 6.08268 43.3858 6.33858C45.4724 5.09842 47.0669 3.11023 47.8347 0.74803C45.8858 1.90944 43.7204 2.73622 41.4173 3.18898C39.5669 1.22047 36.9488 0 34.0551 0C28.4842 0 23.9567 4.52756 23.9567 10.0984C23.9567 10.8858 24.0551 11.6536 24.2126 12.4016C15.8268 11.9882 8.38582 7.95276 3.40551 1.85039C2.53937 3.34646 2.04724 5.07874 2.04724 6.92913C2.04724 10.4331 3.83859 13.5237 6.53543 15.3347C4.88189 15.2756 3.32677 14.8228 1.9685 14.0748C1.9685 14.1142 1.9685 14.1536 1.9685 14.2126C1.9685 19.0944 5.45276 23.189 10.0591 24.1142C9.2126 24.3504 8.32677 24.4686 7.40158 24.4686C6.75197 24.4686 6.12204 24.4094 5.51181 24.2913C6.79133 28.3071 10.5315 31.2204 14.9409 31.2992C11.4763 34.0158 7.12599 35.6299 2.40158 35.6299C1.59449 35.6299 0.787401 35.5906 0 35.4921C4.44882 38.3268 9.76378 40 15.4528 40Z"
								fill="white"
							></path>
						</svg>
					</a>
					<a
						data-v-54e46119=""
						href="https://discord.gg/avp-871990546615386163"
						rel="noopener noreferrer"
						target="_blank"
						class="invisible md:visible"
					>
						<svg
							data-v-54e46119=""
							width="30"
							height="20"
							viewBox="0 0 25 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
							title="Discord logo"
						>
							<path
								data-v-54e46119=""
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M19.98,5.69c-1.68-1.34-4.08-1.71-5.12-1.82h-0.04c-0.16,0-0.31,0.09-0.36,0.24c-0.09,0.23,0.05,0.48,0.28,0.52 c1.17,0.24,2.52,0.66,3.75,1.43c0.25,0.15,0.31,0.49,0.11,0.72c-0.16,0.18-0.43,0.2-0.64,0.08C15.56,5.38,12.58,5.3,12,5.3 S8.44,5.38,6.04,6.86C5.83,6.98,5.56,6.96,5.4,6.78C5.2,6.55,5.26,6.21,5.51,6.06c1.23-0.77,2.58-1.19,3.75-1.43 c0.23-0.04,0.37-0.29,0.28-0.52c-0.05-0.15-0.2-0.24-0.36-0.24H9.14C8.1,3.98,5.7,4.35,4.02,5.69C3.04,6.6,1.09,11.83,1,16.46 c0,0.31,0.08,0.62,0.26,0.87c1.17,1.65,3.71,2.64,5.63,2.78c0.29,0.02,0.57-0.11,0.74-0.35c0.01,0,0.01-0.01,0.02-0.02 c0.35-0.48,0.14-1.16-0.42-1.37c-1.6-0.59-2.42-1.29-2.47-1.34c-0.2-0.18-0.22-0.48-0.05-0.68c0.18-0.2,0.48-0.22,0.68-0.04 c0.03,0.02,2.25,1.91,6.61,1.91s6.58-1.89,6.61-1.91c0.2-0.18,0.5-0.16,0.68,0.04c0.17,0.2,0.15,0.5-0.05,0.68 c-0.05,0.05-0.87,0.75-2.47,1.34c-0.56,0.21-0.77,0.89-0.42,1.37c0.01,0.01,0.01,0.02,0.02,0.02c0.17,0.24,0.45,0.37,0.74,0.35 c1.92-0.14,4.46-1.13,5.63-2.78c0.18-0.25,0.26-0.56,0.26-0.87C22.91,11.83,20.96,6.6,19.98,5.69z M8.89,14.87 c-0.92,0-1.67-0.86-1.67-1.91c0-1.06,0.75-1.92,1.67-1.92c0.93,0,1.67,0.86,1.67,1.92C10.56,14.01,9.82,14.87,8.89,14.87z M15.11,14.87c-0.93,0-1.67-0.86-1.67-1.91c0-1.06,0.74-1.92,1.67-1.92c0.92,0,1.67,0.86,1.67,1.92 C16.78,14.01,16.03,14.87,15.11,14.87z"
								fill="white"
							></path>
						</svg>
					</a>
					<!-- <a
						href="https://opensea.io/collection/averagepunks-"
						rel="noopener noreferrer"
						target="_blank"
						class="px-7 invisible md:visible"
					>
						<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 90 90" fill="none">
							<path
								d="M90 45C90 69.8514 69.8514 90 45 90C20.1486 90 0 69.8514 0 45C0 20.1486 20.1486 0 45 0C69.8566 0 90 20.1486 90 45Z"
								fill="transparent"
							/>
							<path
								d="M22.2011 46.512L22.3952 46.2069L34.1015 27.8939C34.2726 27.6257 34.6748 27.6535 34.8043 27.9447C36.7599 32.3277 38.4475 37.7786 37.6569 41.1721C37.3194 42.5683 36.3947 44.4593 35.3544 46.2069C35.2204 46.4612 35.0724 46.7109 34.9152 46.9513C34.8413 47.0622 34.7164 47.127 34.5823 47.127H22.5432C22.2195 47.127 22.03 46.7756 22.2011 46.512Z"
								fill="#ffffff"
							/>
							<path
								d="M74.38 49.9149V52.8137C74.38 52.9801 74.2783 53.1281 74.1303 53.1928C73.2242 53.5812 70.1219 55.0052 68.832 56.799C65.5402 61.3807 63.0251 67.932 57.4031 67.932H33.9489C25.6362 67.932 18.9 61.1727 18.9 52.8322V52.564C18.9 52.3421 19.0803 52.1618 19.3022 52.1618H32.377C32.6359 52.1618 32.8255 52.4022 32.8024 52.6565C32.7099 53.5072 32.8671 54.3764 33.2693 55.167C34.046 56.7435 35.655 57.7283 37.3933 57.7283H43.866V52.675H37.4673C37.139 52.675 36.9449 52.2959 37.1344 52.0277C37.2038 51.9214 37.2824 51.8104 37.3656 51.6856C37.9712 50.8257 38.8358 49.4895 39.6957 47.9684C40.2829 46.9421 40.8516 45.8463 41.3093 44.746C41.4018 44.5472 41.4757 44.3438 41.5497 44.1449C41.6745 43.7936 41.804 43.4653 41.8964 43.1371C41.9889 42.8597 42.0629 42.5684 42.1369 42.2956C42.3542 41.3617 42.4466 40.3723 42.4466 39.3459C42.4466 38.9437 42.4281 38.523 42.3911 38.1207C42.3727 37.6815 42.3172 37.2423 42.2617 36.8031C42.2247 36.4147 42.1554 36.031 42.0814 35.6288C41.9889 35.0416 41.8595 34.4591 41.7115 33.8719L41.6607 33.65C41.5497 33.2478 41.4572 32.864 41.3278 32.4618C40.9625 31.1996 40.5418 29.9698 40.098 28.8186C39.9362 28.3609 39.7512 27.9217 39.5663 27.4825C39.2935 26.8213 39.0161 26.2203 38.7618 25.6516C38.6324 25.3927 38.5214 25.1569 38.4105 24.9165C38.2856 24.6437 38.1562 24.371 38.0267 24.112C37.9343 23.9132 37.8279 23.7283 37.7539 23.5434L36.9634 22.0824C36.8524 21.8836 37.0373 21.6478 37.2546 21.7079L42.2016 23.0487H42.2155C42.2247 23.0487 42.2293 23.0533 42.234 23.0533L42.8858 23.2336L43.6025 23.437L43.866 23.511V20.5706C43.866 19.1512 45.0033 18 46.4088 18C47.1116 18 47.7496 18.2866 48.2073 18.7536C48.665 19.2206 48.9517 19.8586 48.9517 20.5706V24.935L49.4787 25.0829C49.5203 25.0968 49.5619 25.1153 49.5989 25.143C49.7284 25.2401 49.9133 25.3835 50.1491 25.5591C50.334 25.7071 50.5328 25.8874 50.7733 26.0723C51.2495 26.4561 51.8181 26.9508 52.4423 27.5194C52.6087 27.6628 52.7705 27.8107 52.9185 27.9587C53.7229 28.7076 54.6245 29.5861 55.4844 30.557C55.7248 30.8297 55.9606 31.1071 56.201 31.3984C56.4415 31.6943 56.6957 31.9856 56.9177 32.2769C57.2089 32.6652 57.5233 33.0674 57.7961 33.4882C57.9255 33.687 58.0735 33.8904 58.1983 34.0892C58.5497 34.6209 58.8595 35.1711 59.1554 35.7212C59.2802 35.9755 59.4096 36.2529 59.5206 36.5257C59.8488 37.2608 60.1078 38.0098 60.2742 38.7588C60.3251 38.9206 60.362 39.0963 60.3805 39.2535V39.2904C60.436 39.5124 60.4545 39.7482 60.473 39.9886C60.547 40.756 60.51 41.5235 60.3435 42.2956C60.2742 42.6239 60.1817 42.9336 60.0708 43.2619C59.9598 43.5763 59.8488 43.9045 59.7055 44.2143C59.4281 44.8569 59.0999 45.4996 58.7115 46.1006C58.5867 46.3225 58.4387 46.5583 58.2908 46.7802C58.129 47.016 57.9625 47.238 57.8146 47.4553C57.6112 47.7327 57.3939 48.0239 57.1719 48.2828C56.9731 48.5556 56.7697 48.8284 56.5478 49.0688C56.238 49.434 55.9421 49.7808 55.6324 50.1137C55.4474 50.331 55.2486 50.5529 55.0452 50.7517C54.8464 50.9736 54.643 51.1724 54.458 51.3573C54.1483 51.6671 53.8894 51.9075 53.6721 52.1063L53.1635 52.5733C53.0895 52.638 52.9924 52.675 52.8907 52.675H48.9517V57.7283H53.9079C55.0175 57.7283 56.0716 57.3353 56.9223 56.6141C57.2135 56.3598 58.485 55.2594 59.9876 53.5997C60.0384 53.5442 60.1031 53.5026 60.1771 53.4841L73.8668 49.5265C74.1211 49.4525 74.38 49.6467 74.38 49.9149Z"
								fill="#ffffff"
							/>
						</svg>
					</a> -->
				</div>
			</div>
		</div>
	</header>
</template>

<script>
import Web3ModalMixin from '../mixinWeb3';
import { mapGetters, mapActions } from 'vuex';

export default {
	name: 'AppMenu',
	mixins: [Web3ModalMixin],
	data: () => ({
		openNav: false,
		web3Address: '',
		Web3ModalOptions: {
			theme: 'dark',
		},
		allowedAdmins: [
			'0xd4850927a6e3f30E2e3C3b14D98131Cf8e2D9634',
			'0xd83682D4818D6D044Ce613a19f605c2af7ab6729',
			'0xab7DDe540d93219906CC431cCA83723611312823',
			'0xD97851CEC4c57Cb7dBB114266F579500801adcea',
			'0xBc8f763673483e0c0F0928ffd631368317157354',
			'0xbe1f98c407e7030904fdac86219f5c9fb7029ecf',
			'0xDB1Ac1d3CaCF1bB80e3597bb0EE3CAF52D266dFa',
			'0xa86c148795b0758E6E245f30217bbD5Cdf8D324E',
		],
		allowed: false,
		stickyHeader: false,
		showMenu: false,
    showAppList: false,
		closeTimer: null,
    closeGameTimer: null,
	}),
	computed: {
		...mapGetters({
			metamaskAddress: 'connection/metamaskAddress',
		}),
		btnText() {
			if (!this.web3Account && !this.metamaskAddress) return 'Connect';
			else if (this.web3Account && !this.metamaskAddress) return 'Connect';
			else {
				return (
					this.metamaskAddress.slice(0, 5) +
					'...' +
					this.metamaskAddress.substring(this.metamaskAddress.length - 4, this.metamaskAddress.length)
				);
			}
		},
	},

	methods: {
		...mapActions({
			setMetamaskAddress: 'connection/setMetamaskAddress',
			clearMetamaskAddress: 'connection/clearMetamaskAddress',
		}),
		onBtnClick: async function () {
			try {
				if (!this.web3Account && !this.metamaskAddress) {
					await this.connectWeb3();
					this.setMetamaskAddress(this.web3Account);
				} else {
					await this.disconnectWeb3();
					this.clearMetamaskAddress();
				}
			} catch (error) {
				console.log(error);
			}
		},
		handleScroll() {
			this.stickyHeader = window.scrollY > 20;
		},
		closeMenu() {
			if (this.showMenu) {
				this.showMenu = false;
				window.removeEventListener('click', this.closeMenu);
			}
		},
		showPunksMenu() {
			clearTimeout(this.closeTimer);

			if (this.showMenu) {
				this.showMenu = false;
				window.removeEventListener('click', this.closeMenu);
			} else {
				this.showMenu = true;
				this.closeTimer = setTimeout(() => {
					window.addEventListener('click', this.closeMenu);
				}, 200);
			}
		},
    closeGameMenu(){
      if(this.showAppList) {
        this.showAppList = false;
				window.removeEventListener('click', this.closeGameMenu);
      }
    },
    showGamesMenu(){
      clearTimeout(this.closeGameTimer);

			if (this.showAppList) {
				this.showAppList = false;
				window.removeEventListener('click', this.closeGameMenu);
			} else {
				this.showAppList = true;
				this.closeGameTimer = setTimeout(() => {
					window.addEventListener('click', this.closeGameMenu);
				}, 200);
			}
    }
	},
	watch: {
		metamaskAddress: {
			immediate: true,
			handler: function (val) {
				if (val) {
					const found = this.allowedAdmins.find((a) => a.toLowerCase() === val.toLowerCase());
					this.allowed = found === undefined ? false : true;
				} else {
					this.allowed = false;
				}
			},
		},
	},
	directives: {
		scroll: {
			inserted: function (el, binding) {
				const onScrollCallback = binding.value;
				window.addEventListener('scroll', () => onScrollCallback());
			},
		},
	},
};
</script>
